__turbopack_context__.v({
  "SPosterRow": "IcPvNa_SPosterRow",
  "SWLSearchContentItem": "IcPvNa_SWLSearchContentItem",
  "disabled": "IcPvNa_disabled",
  "includeMargins": "IcPvNa_includeMargins",
});
